import { ValidationErrors, Validator } from '@/entities/validation';
import { ChecklistNotifiableEditable } from '@/ui/DTO';
import { validate as scoreTriggerValidator } from '@/entities/scoreTrigger';

const requiredUsersOrExternalAssignees = (users: number[], externalAssociates: string[]): ValidationErrors => {
  if (users.length === 0 && externalAssociates.length === 0) {
    return [{
      field: 'users',
      type: 'required',
      parameters: [],
    }];
  }

  return [];
};

export const validate: Validator<ChecklistNotifiableEditable> = notifiable => [
  ...(requiredUsersOrExternalAssignees(notifiable.users, notifiable.externalAssociates)),
  ...(scoreTriggerValidator(notifiable.scoreTrigger)),
];
